import MdxWrapper from './src'

export default MdxWrapper
